import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios';

import { loadProgressBar } from 'axios-progress-bar'

Vue.use(Vuex);
const DEBUG = true;

const MAIL = 'https://codigo46.me/backMail/mail/specific';

const URL = 'https://factura-api.herokuapp.com/api/';
//const URL = 'http://localhost:9095/api/';

var store = new Vuex.Store({
    state: {
        usuario: {},
        loading: false,
        showLogin: false,
        menu: true,
        refresh: true,
        totales: {
            productos: {
                total_results: 0
            },
            clientes: {
                total_results: 0
            }
        },
        showLoginAnimated: false,
    },
    mutations: {
        SET_USUARIO (state, usuario) {
            state.usuario = usuario
        },
        SET_LOADING (state, loading) {
            state.loading = loading
        },
        SET_SHOW_LOGIN (state, showLogin) {
            state.showLogin = showLogin
        },
        SET_SHOW_LOGIN_ANIMATED (state, showLogin) {
            state.showLoginAnimated = showLogin
        },
        SET_MENU (state, menu) {
            state.menu = menu
        },
        SET_REFRSH (state, refresh) {
            state.refresh = refresh
        },
        SET_TOTALES (state, totales) {
            state.totales = totales
        },
    },
    actions: {

        login_API(context,data) {
            loadProgressBar();
            context.commit('SET_LOADING', true);

            return new Promise((resolve, reject) => {
                axios({
                    method: 'post',
                    url: URL + 'login',
                    data: data,
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(data => {
                    context.commit('SET_USUARIO', data.data.current);
                    context.commit('SET_LOADING', false);
                    context.commit('SET_SHOW_LOGIN', false);
                    context.commit('SET_SHOW_LOGIN_ANIMATED', false);
                    resolve(data.data);
                }).catch(error => {
                    setTimeout(function () {
                        context.commit('SET_LOADING', false);
                        reject(error);
                    }, 1000);
                });
            });
        },


        getProductos(context,data) {
            loadProgressBar();
            context.commit('SET_LOADING', true);

            return new Promise((resolve, reject) => {
                axios({
                    method: 'post',
                    url: URL + 'producto/find',
                    data: data,
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(data => {
                    context.commit('SET_LOADING', false);
                    if (DEBUG)
                        console.log('%c 🚙: Productos', 'background: #222; color: #bada55; font-size:18px;', data.data);
                    resolve(data.data);
                }).catch(error => {
                    setTimeout(function () {
                        context.commit('SET_LOADING', false);
                        reject(error);
                    }, 1000);
                });
            });
        },

        postSaveProducto(context,data) {
            loadProgressBar();
            context.commit('SET_LOADING', true);

            return new Promise((resolve, reject) => {
                axios({
                    method: 'post',
                    url: URL + 'producto/save',
                    data: data,
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(data => {
                    context.commit('SET_LOADING', false);
                    if (DEBUG)
                        console.log('%c 🚙: Add Productos', 'background: #222; color: #bada55; font-size:18px;', data.data);
                    resolve(data.data);
                }).catch(error => {
                    setTimeout(function () {
                        context.commit('SET_LOADING', false);
                        reject(error);
                    }, 1000);
                });
            });
        },

        getProductoById(context,data) {
            loadProgressBar();
            context.commit('SET_LOADING', true);

            return new Promise((resolve, reject) => {
                axios({
                    method: 'post',
                    url: URL + 'producto/findId',
                    data: data,
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(data => {
                    context.commit('SET_LOADING', false);
                    if (DEBUG)
                        console.log('%c 🚙: Productos By ID', 'background: #222; color: #bada55; font-size:18px;', data.data);
                    resolve(data.data);
                }).catch(error => {
                    setTimeout(function () {
                        context.commit('SET_LOADING', false);
                        reject(error);
                    }, 1000);
                });
            });
        },

        getProductoUpdate(context,data) {
            loadProgressBar();
            context.commit('SET_LOADING', true);

            return new Promise((resolve, reject) => {
                axios({
                    method: 'post',
                    url: URL + 'producto/update',
                    data: data,
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(data => {
                    context.commit('SET_LOADING', false);
                    if (DEBUG)
                        console.log('%c 🚙: Productos By ID', 'background: #222; color: #bada55; font-size:18px;', data.data);
                    resolve(data.data);
                }).catch(error => {
                    setTimeout(function () {
                        context.commit('SET_LOADING', false);
                        reject(error);
                    }, 1000);
                });
            });
        },

        getCliente(context,data) {
            loadProgressBar();
            context.commit('SET_LOADING', true);

            return new Promise((resolve, reject) => {
                axios({
                    method: 'post',
                    url: URL + 'cliente/find',
                    data: data,
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(data => {
                    context.commit('SET_LOADING', false);
                    if (DEBUG)
                        console.log('%c 🚙: Clientes', 'background: #222; color: #bada55; font-size:18px;', data.data);
                    resolve(data.data);
                }).catch(error => {
                    setTimeout(function () {
                        context.commit('SET_LOADING', false);
                        reject(error);
                    }, 1000);
                });
            });
        },

        getClienteById(context,data) {
            loadProgressBar();
            context.commit('SET_LOADING', true);

            return new Promise((resolve, reject) => {
                axios({
                    method: 'post',
                    url: URL + 'cliente/findId',
                    data: data,
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(data => {
                    context.commit('SET_LOADING', false);
                    if (DEBUG)
                        console.log('%c 🚙: Clientes By ID', 'background: #222; color: #bada55; font-size:18px;', data.data);
                    resolve(data.data);
                }).catch(error => {
                    setTimeout(function () {
                        context.commit('SET_LOADING', false);
                        reject(error);
                    }, 1000);
                });
            });
        },

        postSaveCliente(context,data) {
            loadProgressBar();
            context.commit('SET_LOADING', true);

            return new Promise((resolve, reject) => {
                axios({
                    method: 'post',
                    url: URL + 'cliente/save',
                    data: data,
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(data => {
                    context.commit('SET_LOADING', false);
                    if (DEBUG)
                        console.log('%c 🚙: Clientes', 'background: #222; color: #bada55; font-size:18px;', data.data);
                    resolve(data.data);
                }).catch(error => {
                    setTimeout(function () {
                        context.commit('SET_LOADING', false);
                        reject(error);
                    }, 1000);
                });
            });
        },

        postUpdateCliente(context,data) {
            loadProgressBar();
            context.commit('SET_LOADING', true);

            return new Promise((resolve, reject) => {
                axios({
                    method: 'post',
                    url: URL + 'cliente/update',
                    data: data,
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(data => {
                    context.commit('SET_LOADING', false);
                    if (DEBUG)
                        console.log('%c 🚙: Clientes', 'background: #222; color: #bada55; font-size:18px;', data.data);
                    resolve(data.data);
                }).catch(error => {
                    setTimeout(function () {
                        context.commit('SET_LOADING', false);
                        reject(error);
                    }, 1000);
                });
            });
        },

        getProductKey(context,data) {
            loadProgressBar();
            context.commit('SET_LOADING', true);

            return new Promise((resolve, reject) => {
                axios({
                    method: 'get',
                    url: URL + 'producto/getProductKey',
                    data: data,
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(data => {
                    context.commit('SET_LOADING', false);
                    if (DEBUG)
                        console.log('%c 🚙: Productos Key', 'background: #222; color: #bada55; font-size:18px;', data.data);
                    resolve(data.data);
                }).catch(error => {
                    setTimeout(function () {
                        context.commit('SET_LOADING', false);
                        reject(error);
                    }, 1000);
                });
            });
        },

        getUnidadKey(context,data) {
            loadProgressBar();
            context.commit('SET_LOADING', true);

            return new Promise((resolve, reject) => {
                axios({
                    method: 'get',
                    url: URL + 'producto/getUnidadKey',
                    data: data,
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(data => {
                    context.commit('SET_LOADING', false);
                    if (DEBUG)
                        console.log('%c 🚙: Productos Unidad', 'background: #222; color: #bada55; font-size:18px;', data.data);
                    resolve(data.data);
                }).catch(error => {
                    setTimeout(function () {
                        context.commit('SET_LOADING', false);
                        reject(error);
                    }, 1000);
                });
            });
        },

        getTotales(context) {
            loadProgressBar();
            context.commit('SET_LOADING', true);

            return new Promise((resolve, reject) => {
                axios({
                    method: 'post',
                    url: URL + 'totales',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(data => {
                    context.commit('SET_LOADING', false);
                    if (DEBUG)
                        console.log('%c 🚙: Totales', 'background: #222; color: #bada55; font-size:18px;', data.data);
                    resolve(data.data);
                }).catch(error => {
                    setTimeout(function () {
                        context.commit('SET_LOADING', false);
                        reject(error);
                    }, 1000);
                });
            });
        },

    }
})

export default store
